import React, { Component } from 'react'
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import RemoveGroupMapping from '../removeGroupMapping';
import styles from './style.scss';

export default class LdapGroupMappingGrid extends Component {
    
    formatServerName = (serverName) => {

        return <div 
                    className={classNames(styles.ldapRowInnerWrapper)}
                    title={serverName}
                >
                    <span className={classNames(styles.ldapServerName)}>{serverName}</span>
                </div>;
    }

    formatGroupName = (ldapGroupDn) => {

        return <div 
                    className={classNames(styles.ldapRowInnerWrapper)}
                    title={ldapGroupDn}
                >
                    {ldapGroupDn}
                </div>;
    }

    formatLdapGroupDisplayName = (ldapGroupDisplayName) => {

        return <div 
                    className={classNames(styles.ldapRowInnerWrapper)}
                    title={ldapGroupDisplayName}
                >
                    {ldapGroupDisplayName}
                </div>;
    }

    formatRemoveMember = (id, rowData) => {

        return <RemoveGroupMapping id={id} groupName={rowData.ldapGroupDisplayName} ldapGroupDn={rowData.ldapGroupDn} />;
    }

    render() {
    
        const { ldapTeamMappings } = this.props;
        const options = {
            sizePerPage: 11,
            hideSizePerPage: true
        };

        const table = <BootstrapTable
                            data={ldapTeamMappings}
                            options={options}
                            striped
                            hover
                            pagination
                            tableContainerClass={classNames(styles.innerTableContainerWrapper)}
                            bodyContainerClass={classNames(styles.tableBodyWrapper)}
                            headerContainerClass={classNames(styles.innerTabGridHeader)}
                            trClassName={classNames(styles.tableRow)}
                        >                        
                            <TableHeaderColumn isKey dataField='serverName' 
                                className='table-header user-full-name-header-column'
                                width='250px'
                                dataFormat={this.formatServerName}
                            >
                                {this.props.translations.ldapServer}
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField='ldapGroupDisplayName' className='table-header'
                                width='300px'
                                dataFormat={this.formatGroupName}
                            >
                                {this.props.translations.group}
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField='ldapGroupDn' className='table-header'
                                dataFormat={this.formatLdapGroupDisplayName}
                            >
                                {this.props.translations.groupDn}
                            </TableHeaderColumn>

                            <TableHeaderColumn dataField='id' className='table-header' width='100px'
                                    dataFormat={this.formatRemoveMember}>
                            </TableHeaderColumn>
                        </BootstrapTable>;

        return (
            <div>
                <Scrollbars
                    style={{ height: '70vh', width: '100%' }}
                >
                    <div className='portal-light-grid organization-users-grid'
                        style={{height: '63vh'}}
                    >
                        {table}
                    </div>
                </Scrollbars>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/ldapGroupMapping/ldapGroupMappingGrid/index.jsx